export default {"src":"/_next/static/media/rp-cwe.9f8e56c0.svg","height":35,"width":100,"blurWidth":0,"blurHeight":0};